import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Checkbox, Select, Table,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';

import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const QCRejectionNotification = ({
  createQCPointLoading, updateQCPointLoading, qcRejectionData, updateQcRejectionData,
}) => {
  useEffect(() => {
    updateQcRejectionData([
      {
        operation_name: 'Purchase Receipt',
        enable_notification: true,
        recipients: [
          { key: 1, value: 'VENDOR' },
          { key: 2, value: 'INITIATOR' },
          { key: 3, value: 'APPROVERS' },
        ],
        value: ['VENDOR', 'INITIATOR', 'APPROVERS'],
        additional_recipients: [],
      },
      {
        operation_name: 'Manufacturing Order',
        enable_notification: true,
        recipients: [
          { key: 1, value: 'INITIATOR' },
        ],
        value: ['INITIATOR'],
        additional_recipients: [],
      },
      {
        operation_name: 'External Transfer Receipt',
        enable_notification: true,
        recipients: [
          { key: 1, value: 'INITIATOR' },
          { key: 2, value: 'APPROVERS' },
          { key: 3, value: 'TRANSFER RECIPIENTS' },
        ],
        value: ['INITIATOR', 'APPROVERS', 'TRANSFER RECIPIENTS'],
        additional_recipients: [],
      },
      {
        operation_name: 'Internal Transfer Receipt',
        enable_notification: true,
        recipients: [
          { key: 1, value: 'INITIATOR' },
          { key: 2, value: 'APPROVERS' },
        ],
        value: ['INITIATOR', 'APPROVERS'],
        additional_recipients: [],
      },
    ]);
  }, []);

  const getQCRejectionColumn = () => {
    const qcRejectionColumn = [
      {
        title: 'Operation',
        width: '250px',
        render: (record) => (
          <div style={{ paddingLeft: '8px' }}>
            <H3Text text={record?.operation_name?.toProperCase()} />
          </div>
        ),
      },
      {
        title: 'Enable Notification',
        width: '150px',
        render: (record) => (
          <Fragment>
            <div style={{ paddingLeft: '8px' }}>
              <Checkbox
                checked={record?.enable_notification}
                onChange={(event) => {
                  const copyCustomInputData = JSON.parse(JSON.stringify(qcRejectionData));
                  copyCustomInputData.map((item) => {
                    if (item.operation_name === record.operation_name) {
                      item.enable_notification = event?.target?.checked;
                    }
                    return item;
                  });
                  updateQcRejectionData(copyCustomInputData);
                }}
              />
            </div>
          </Fragment>
        ),
      },
      {
        title: 'Recipients',
        width: '200px',
        render: (record) => (
          <Fragment>
              <PRZSelect
                mode="multiple"
                value={record?.value}
                onChange={(value) => {
                  const copyCustomInputData = JSON.parse(JSON.stringify(qcRejectionData));
                  copyCustomInputData.map((item) => {
                    if (item.operation_name === record.operation_name) {
                      item.value = value;
                    }
                    return item;
                  });
                  updateQcRejectionData(copyCustomInputData);
                }}
                maxTagCount="responsive"
                placeholder=""
              >
                {record?.recipients?.map((recipient) => (
                  <Option key={recipient?.key} value={recipient?.value}>{recipient?.value?.toProperCase()}</Option>
                ))}
              </PRZSelect>
          </Fragment>
        ),
      },
      {
        title: 'Additional Recipients',
        render: (record) => (
          <Fragment>
              <PRZSelect
                mode="tags"
                value={record?.additional_recipients}
                onChange={(value) => {
                  const copyCustomInputData = JSON.parse(JSON.stringify(qcRejectionData));
                  copyCustomInputData.map((item) => {
                    if (item.operation_name === record.operation_name) {
                      const recipients = [];
                      for (let i = 0; i < value?.length; i++) {
                        if (Helpers.validateEmail(value[i])) {
                          recipients.push(value[i]);
                        }
                      }
                      item.additional_recipients = recipients;
                    }
                    return item;
                  });
                  updateQcRejectionData(copyCustomInputData);
                }}
                maxTagCount="responsive"
                style={{
                  height: 'auto !important',
                }}
                placeholder=""
              />
          </Fragment>
        ),
      },
    ];

    return qcRejectionColumn;
  };

  return (
    <div className="qc-notification__wrapper">
      <Table
        bordered
        loading={updateQCPointLoading || createQCPointLoading}
        showHeader
        size="small"
        scroll="scroll"
        columns={getQCRejectionColumn()}
        dataSource={qcRejectionData}
        pagination={false}
      />
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, QCPointReducers,
}) => ({
  user: UserReducers.user,
  createQCPointLoading: QCPointReducers.createQCPointLoading,
  updateQCPointLoading: QCPointReducers.updateQCPointLoading,
});

const mapDispatchToProps = (dispatch) => ({

});

QCRejectionNotification.propTypes = {
  qcRejectionData: PropTypes.any,
  updateQcRejectionData: PropTypes.any,
  createQCPointLoading: PropTypes.bool,
  updateQCPointLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QCRejectionNotification));
